import type { InjectionKey, Ref } from 'vue'

/** Shared by `AppCollapseGroup` (accordion) and its `AppCollapse` children: the id of the one open item. */
export const COLLAPSE_GROUP: InjectionKey<{ openId: Ref<string | null> }> = Symbol('AppCollapseGroup')
